/**
 * @author PoornaChandu
 */
import axios from 'axios';
import moment from 'moment-timezone';
import Querybuilder from './queryBuilder';
import { DatePicker, message } from 'antd';
import localStorage from '../../../../utils/localStorage';
import StyledTable from "../../../../commons/styles/table";
import React, { Fragment, useEffect, useState } from 'react';
import { AnalysisButton, ChildTablesGroup, StyledModal } from './style';

const AIFaults = () => {
  const [loading, setLoading] = useState(false);
  const [faultData, setFaultData] = useState([]);
  const [faultCode, setFaultCode] = useState([]);
  const [columnData, setColumnData] = useState([]);
  const [modelOpen, setModelOpen] = useState(false);
  const [analyseData, setAnalyseData] = useState({});
  const [selectedDate, setSelectedDate] = useState(moment());
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [columnFilters, setColumnFilters] = useState({
    Location: [],
    Status: [],
    'Device Name': [],
    'Fault Code': [],
    Device: []
  });

  useEffect(() => {
    const fetchInitialData = async () => {
      const SiteId = localStorage.get('currentSite');
      let accessToken = localStorage.get('accessToken');
      try {
        setLoading(true);
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        };
        const reportResponse = await axios.get(`/api/report/get?SiteId=${SiteId}`, { headers });
        const filteredObjects = reportResponse.data.filter(
          (item) => item.Type === 'Predefined' && item.ReportName === 'Fault Analysis Report'
        );
        const startDate = moment()
          .subtract(1, 'day')
          .set({ hour: 18, minute: 30, second: 0 })
          .format('YYYY-MM-DD HH:mm:ss');
        const endDate = moment()
          .set({ hour: 18, minute: 29, second: 59 })
          .format('YYYY-MM-DD HH:mm:ss');
        const payload = JSON.stringify({
          startDate,
          endDate,
          ...filteredObjects[0].JSON.api.payload,
          SiteId
        });
        const dataResponse = await axios.post(
          `${filteredObjects[0].JSON.api.uri}?SiteId=${SiteId}`,
          payload,
          { headers }
        );
        const responseData = dataResponse.data;
        const newFilters = {
          Location: Array.from(new Set(responseData.map((item) => item['Location']))).map(
            (code) => ({ text: code, value: code })
          ),
          Status: Array.from(new Set(responseData.map((item) => item['Status']))).map((code) => ({
            text: code,
            value: code
          })),
          'Device Name': Array.from(new Set(responseData.map((item) => item['Device Name']))).map(
            (code) => ({ text: code, value: code })
          ),
          'Fault Code': Array.from(new Set(responseData.map((item) => item['Fault Code']))).map(
            (code) => ({ text: code, value: code })
          ),
          Device: Array.from(new Set(responseData.map((item) => item['Device']))).map((code) => ({
            text: code,
            value: code
          }))
        };
        const dynamicColumns = filteredObjects[0].JSON.columns
          .map((col) => ({
            title: col.title,
            dataIndex: col.dataIndex,
            key: col.key,
            ...(col.dataIndex === 'Location' && {
              filters: newFilters.Location,
              onFilter: (value, record) => record['Location'] === value
            }),
            ...(col.dataIndex === 'Status' && {
              filters: newFilters.Status,
              onFilter: (value, record) => record['Status'] === value
            }),
            ...(col.dataIndex === 'Fault Code' && {
              filters: newFilters['Fault Code'],
              onFilter: (value, record) => record['Fault Code'] === value
            })
          }))
          .concat([
            {
              title: 'Device Code',
              dataIndex: 'Device',
              key: 'Device',
              filters: newFilters.Device,
              onFilter: (value, record) => record['Device'] === value
            },
            {
              title: 'Analyse',
              key: 'analyse',
              render: (text, record) => (
                <AnalysisButton
                  style={{ color: '#1a3652' }}
                  onClick={async () => {
                    let faultCode = record['Fault Code'];
                    setFaultCode(record['Fault Code']);
                    let createdTime = record['Fault Start Time'];
                    let deviceValue = record['Device'];
                    try {
                      await AnalyseAPICall(faultCode, createdTime, deviceValue);
                    } catch (e) {
                      message.error('API Call Failed:', e);
                    }
                    setLoading(false);
                  }}
                >
                  Analyse
                </AnalysisButton>
              )
            }
          ]);
        setColumnFilters(newFilters);
        setColumnData(dynamicColumns);
        setFilteredDataSource(responseData);
      } catch (error) {
        console.error('Error fetching initial data:', error);
        message.error('Failed to load initial data');
      } finally {
        setLoading(false);
      }
    };
    fetchInitialData();
  }, []);

  useEffect(() => {
    onDateChange(moment());
  }, []);

  const disabledDate = (current) => {
    return current && current > moment().endOf('day');
  };

  const onDateChange = async (date) => {
    setSelectedDate(date);
    const startDate = moment(date)
      .subtract(1, 'day')
      .set({ hour: 18, minute: 30, second: 0 })
      .format('YYYY-MM-DD HH:mm:ss');
    const endDate = moment(date)
      .set({ hour: 18, minute: 29, second: 59 })
      .format('YYYY-MM-DD HH:mm:ss');
    const dateToSend = {
      startDate: startDate,
      endDate: endDate
    };
    const newTagsArray = [
      'Location',
      'Fault Start Time',
      'Fault Code',
      'Fault Description',
      'Device Name',
      'Device',
      'Status'
    ];
    const SiteId = localStorage.get('currentSite');
    let accessToken = localStorage.get('accessToken');
    try {
      setLoading(true);
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      };
      const response = await axios.get(`/api/report/get?SiteId=${SiteId}`, { headers });
      const data = response.data;
      const filteredObjects = data.filter(
        (item) => item.Type === 'Predefined' && item.ReportName === 'Fault Analysis Report'
      );
      const columnData = filteredObjects[0].JSON.columns;
      const dynamicColumns = columnData.map((col) => ({
        title: col.title,
        dataIndex: col.dataIndex,
        key: col.key,
        ...(col.dataIndex === 'Location' && {
          filters: columnFilters.Location,
          onFilter: (value, record) => record['Location'] === value
        }),
        ...(col.dataIndex === 'Status' && {
          filters: columnFilters.Status,
          onFilter: (value, record) => record['Status'] === value
        }),
        ...(col.dataIndex === 'Device Name' && {
          filters: columnFilters['Device Name'],
          onFilter: (value, record) => record['Device Name'] === value
        }),
        ...(col.dataIndex === 'Fault Code' && {
          filters: columnFilters['Fault Code'],
          onFilter: (value, record) => record['Fault Code'] === value
        })
      }));
      const manualColumns = [
        {
          title: 'Device Code',
          dataIndex: 'Device',
          key: 'Device',
          filters: Array.from(new Set(filteredDataSource.map((item) => item['Device']))).map(
            (code) => ({ text: code, value: code })
          ),
          onFilter: (value, record) => record['Device'] === value
        },
        {
          title: 'Analyse',
          render: (record) => {
            return (
              <AnalysisButton
                style={{ color: '#1a3652' }}
                onClick={async () => {
                  let faultCode = record['Fault Code'];
                  setFaultCode(record['Fault Code']);
                  let createdTime = record['Fault Start Time'];
                  let deviceValue = record['Device'];
                  try {
                    await AnalyseAPICall(faultCode, createdTime, deviceValue);
                  } catch (e) {
                    message.error('API Call Failed :', e);
                  }
                  setLoading(false);
                }}
              >
                Analyse
              </AnalysisButton>
            );
          }
        }
      ];
      setColumnData([...dynamicColumns, ...manualColumns]);
      if (filteredObjects.length > 0 && filteredObjects[0].JSON.api.payload.TagsList) {
        filteredObjects[0].JSON.api.payload.TagsList = [
          ...filteredObjects[0].JSON.api.payload.TagsList,
          ...newTagsArray
        ];
      } else {
        console.error('Taglist not found');
      }
      const resdata = JSON.stringify({
        ...dateToSend,
        ...filteredObjects[0].JSON.api.payload,
        SiteId
      });
      const response2 = await axios.post(
        `${filteredObjects[0].JSON.api.uri}?SiteId=${SiteId}`,
        resdata,
        { headers }
      );
      const responseData = response2.data;
      setFilteredDataSource(responseData);
    } catch (error) {
      console.error('Error Fetching data : ', error);
    } finally {
      setLoading(false);
    }
  };

  const AnalyseAPICall = async (faultCode, createdTime, deviceValue) => {
    const SiteId = localStorage.get('currentSite');
    let accessToken = localStorage.get('accessToken');
    try {
      setLoading(true);
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      };
      const payload = {
        SiteId: `${SiteId}`,
        SelectedValue: faultCode,
        CreatedTime: createdTime,
        Device: deviceValue
      };
      const response = await axios.post(`/api/analysis/create?SiteId=${SiteId}`, payload, {
        headers
      });
      if (response.status === 200) {
        const data = await response.data;
        if (data.Answer !== null) {
          setAnalyseData(data);
        }
        setFaultData([data.Table_content]);
        setModelOpen(true);
      } else {
        message.error('API Error Fetching Data');
      }
    } catch (e) {
      message.error('API Error Fetching Data');
    }
  };

  const onCancelModel = () => {
    setAnalyseData(null);
    setFaultData([]);
    setModelOpen(false);
  };

  const faultColumns = [
    {
      title: 'Fault No',
      dataIndex: 'Fault no',
      key: 'Fault no'
    },
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name'
    },
    {
      title: 'Steps to Troubleshoot',
      dataIndex: 'Steps to Troubleshoot',
      key: 'Steps to Troubleshoot'
    }
  ];

  return (
    <div>
      <ChildTablesGroup style={{ minHeight: window.innerHeight - 67 }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <DatePicker
            style={{ marginBottom: '10px' }}
            value={moment(selectedDate, 'YYYY-MM-DD')}
            onChange={onDateChange}
            disabledDate={disabledDate}
            allowClear={false}
          />
        </div>
          <StyledTable size="small"
            dataSource={filteredDataSource}
            columns={columnData}
            loading={loading}
            
            bordered={true}
            rowKey="id"
            pagination={filteredDataSource.length > 10 ? { pageSize: '10' } : false}
          />
      </ChildTablesGroup>
      <StyledModal
        open={modelOpen}
        onCancel={onCancelModel}
        width="90vw"
        footer={null}
        closable={true}
        title={`Analyse AI Fault Code : ${faultCode}`}
      >
        <Fragment>
          <div>{analyseData?.Answer ? <Querybuilder queryData={analyseData.Answer} /> : null}</div>
          <div>
            {faultData.length > 0 ? (
                <StyledTable size="small"
                  columns={faultColumns}
                  dataSource={faultData}
                  
                  bordered={true}
                />
            ) : null}
          </div>
        </Fragment>
      </StyledModal>
    </div>
  );
};

export default AIFaults;
